import { Component, OnInit } from '@angular/core';
import { LoginService } from '../home/login.service';

@Component({
  standalone: false,
    templateUrl: './welcome.component.html'
})
export class WelcomeComponent implements OnInit {
    public pageTitle: string = 'Welcome';

    constructor(private _loginService: LoginService) {
    }

    ngOnInit(): void {
        // this._loginService.refreshToken()
        // .subscribe()
    }
}
